<div class="rs-page">

  <div class="rs-tabs">
    <button class="rs-tab" [class.active]="activeTab==='pattern'" (click)="activeTab='pattern'">
      <mat-icon>grid_view</mat-icon> Work Pattern (WFO / WFH)
    </button>
    <button class="rs-tab" [class.active]="activeTab==='shifts'" (click)="activeTab='shifts'">
      <mat-icon>event_available</mat-icon> Shift Assignment
    </button>
    <button class="rs-tab" [class.active]="activeTab==='requests'" (click)="activeTab='requests'">
      <mat-icon>published_with_changes</mat-icon> Change Requests
    </button>
  </div>

  <div class="rs-skel sk-fade" *ngIf="loading">
    <div class="rs-toolbar">
      <div class="rs-week-nav" style="border:none;background:transparent;padding:0;gap:8px">
        <span class="sk" style="width:32px;height:32px;border-radius:8px"></span>
        <span class="sk-line" style="width:150px;height:15px"></span>
        <span class="sk" style="width:32px;height:32px;border-radius:8px"></span>
      </div>
      <span class="sk" style="width:210px;height:38px;border-radius:9px"></span>
      <span class="sk" style="width:150px;height:38px;border-radius:9px"></span>
      <div style="display:flex;gap:8px">
        <span class="sk-chip" *ngFor="let l of [1,2,3,4]" style="width:52px"></span>
      </div>
      <span class="sk-btn" style="width:130px;margin-left:auto"></span>
    </div>

    <div class="rs-card sk-surface" style="padding:0;overflow:hidden;margin-top:14px">
      <div class="rs-skel-grid rs-skel-head">
        <span class="sk-line" style="width:80px"></span>
        <span class="sk-line" style="width:70px"></span>
        <span class="sk-line" style="width:90px"></span>
        <span class="sk-line" *ngFor="let d of [1,2,3,4,5,6]" style="width:40px;margin:0 auto"></span>
        <span class="sk-line" style="width:40px;margin:0 auto"></span>
      </div>
      <div class="rs-skel-grid rs-skel-row" *ngFor="let r of [1,2,3,4,5,6,7,8]">
        <div style="display:flex;align-items:center;gap:10px">
          <span class="sk-circle" style="width:34px;height:34px"></span>
          <div class="sk-stack" style="gap:6px"><span class="sk-line" style="width:96px"></span><span class="sk-line sk-sm" style="width:60px"></span></div>
        </div>
        <span class="sk-chip" style="width:84px"></span>
        <span class="sk-line" style="width:70%"></span>
        <span class="sk" *ngFor="let d of [1,2,3,4,5,6]" style="height:30px;border-radius:7px"></span>
        <span class="sk" style="width:30px;height:30px;border-radius:8px;margin:0 auto"></span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="activeTab==='pattern' && !loading">
    <div class="rs-toolbar">
      <div class="rs-week-nav">
        <button class="rs-week-btn" (click)="shiftWeek(-1)"><mat-icon>chevron_left</mat-icon></button>
        <span class="rs-week-label">{{ weekDays[0]?.date | date:'d MMM' }} – {{ weekDays[5]?.date | date:'d MMM yyyy' }}</span>
        <button class="rs-week-btn" (click)="shiftWeek(1)"><mat-icon>chevron_right</mat-icon></button>
      </div>
      <div class="rs-search">
        <mat-icon>search</mat-icon>
        <input type="text" placeholder="Search employee…" [(ngModel)]="searchText" (ngModelChange)="rebuildRows()">
      </div>
      <select class="rs-select" [(ngModel)]="filterDept" (ngModelChange)="rebuildRows()">
        <option value="all">All Departments</option>
        <option *ngFor="let d of departments" [value]="d.id">{{ d.name }}</option>
      </select>
      <div class="rs-legend">
        <span class="rs-lg rs-cell--wfo">WFO</span>
        <span class="rs-lg rs-cell--wfh">WFH</span>
        <span class="rs-lg rs-cell--holiday">Holiday</span>
        <span class="rs-lg rs-cell--off">Off</span>
      </div>
      <button class="rs-add-btn rs-export-btn" (click)="exportExcel()"><mat-icon>download</mat-icon> Export Excel</button>
    </div>

    <div class="rs-bulk">
      <mat-icon>groups</mat-icon>
      <span class="rs-bulk-label">Set all {{ rows.length }} shown to</span>
      <select class="rs-select" [(ngModel)]="bulkType">
        <option *ngFor="let t of workTypeOptions" [value]="t">{{ t }}</option>
      </select>
      <div class="rs-day-picker" *ngIf="bulkType==='Hybrid'">
        <button type="button" class="rs-day-chip rs-day-chip--sm" *ngFor="let d of WEEKDAY_PICKER"
                [class.active]="bulkDays.includes(d.code)" (click)="toggleBulkDay(d.code)">{{ d.label }}</button>
      </div>
      <button class="rs-add-btn rs-bulk-apply" (click)="applyBulk()"><mat-icon>done_all</mat-icon> Apply to all</button>
      <button class="rs-add-btn rs-notify-all" *ngIf="isHrAdmin()" [disabled]="notifyingAll" (click)="notifyAll()">
        <mat-icon>notifications_active</mat-icon> Notify all
      </button>
    </div>

    <div class="rs-card">
      <div class="rs-grid-wrap">
        <table class="rs-grid" *ngIf="rows.length; else empty2">
          <thead>
            <tr>
              <th class="rs-sticky">Employee</th>
              <th>Work Type</th>
              <th>Office Days (tap to edit)</th>
              <th class="rs-day-th" *ngFor="let d of weekDays">
                <div class="rs-day-dow">{{ d.code | titlecase }}</div>
                <div class="rs-day-num">{{ d.date | date:'d MMM' }}</div>
              </th>
              <th class="rs-center" *ngIf="isHrAdmin()">Notify</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of rows; trackBy: trackByEmp">
              <td class="rs-sticky">
                <div class="rs-emp rs-emp--click" (click)="openEmpDrawer(r.emp)" matTooltip="View details & change timeline">
                  <div class="rs-av">{{ initials(r.emp) }}</div>
                  <div><div class="rs-emp-name">{{ empName(r.emp) }}</div><div class="rs-emp-code">{{ deptName(r.emp.departmentId) }}</div></div>
                </div>
              </td>
              <td>
                <select class="rs-wt-select rs-wt--{{ workTypeOf(r.emp) | lowercase }}"
                        [ngModel]="workTypeOf(r.emp)" (ngModelChange)="setWorkType(r.emp, $event)">
                  <option *ngFor="let t of workTypeOptions" [value]="t">{{ t }}</option>
                </select>
              </td>
              <td>
                <div class="rs-day-picker" *ngIf="workTypeOf(r.emp)==='Hybrid'; else patLbl">
                  <button type="button" class="rs-day-chip rs-day-chip--sm" *ngFor="let d of WEEKDAY_PICKER"
                          [class.active]="officeDaysOf(r.emp).includes(d.code)" (click)="toggleDay(r.emp, d.code)">{{ d.label }}</button>
                </div>
                <ng-template #patLbl><span class="rs-pat">{{ patternLabel(r.emp) }}</span></ng-template>
              </td>
              <td class="rs-day-td" *ngFor="let d of weekDays">
                <button type="button" class="rs-cell" [ngClass]="'rs-cell--' + dayState(r.emp, d)"
                      [class.rs-cell--locked]="dayState(r.emp, d)==='holiday'"
                      [disabled]="dayState(r.emp, d)==='holiday'"
                      [matTooltip]="dayState(r.emp, d)==='holiday' ? holidayName(d.date) : 'Click to toggle WFO / WFH'"
                      (click)="toggleCell(r.emp, d)">
                  {{ cellLabel(dayState(r.emp, d)) }}
                </button>
              </td>
              <td class="rs-center" *ngIf="isHrAdmin()">
                <button class="rs-act rs-act--notify" matTooltip="Notify employee + manager + HR of this pattern"
                        [disabled]="notifyingId[r.emp.id]" (click)="notifyPattern(r.emp)">
                  <mat-icon>{{ notifyingId[r.emp.id] ? 'hourglass_empty' : 'notifications_active' }}</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <ng-template #empty2><div class="rs-empty"><mat-icon>grid_view</mat-icon><p>No employees match the filters</p></div></ng-template>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="activeTab==='shifts' && !loading">
  <div class="rs-toolbar">
    <div class="rs-search">
      <mat-icon>search</mat-icon>
      <input type="text" placeholder="Search employee / ID…" [(ngModel)]="searchText" (ngModelChange)="rebuildRows()">
    </div>
    <select class="rs-select" [(ngModel)]="filterDept" (ngModelChange)="rebuildRows()">
      <option value="all">All Departments</option>
      <option *ngFor="let d of departments" [value]="d.id">{{ d.name }}</option>
    </select>
    <select class="rs-select" [(ngModel)]="filterShift" (ngModelChange)="rebuildRows()">
      <option value="all">All Shifts</option>
      <option value="unassigned">Unassigned</option>
      <option *ngFor="let s of shifts" [value]="s.id">{{ s.name }}</option>
    </select>
    <button class="rs-defs-btn" (click)="showShiftDefs=true" title="Create / edit shift types"><mat-icon>schedule</mat-icon> Shift Definitions</button>
    <button class="rs-add-btn" (click)="openAssign()"><mat-icon>add</mat-icon> Assign Shift</button>
  </div>

  <div class="rs-defs-scrim" *ngIf="showShiftDefs" (click)="closeShiftDefs()">
    <div class="rs-defs-modal" (click)="$event.stopPropagation()">
      <div class="rs-defs-head">
        <div><mat-icon>schedule</mat-icon> <span>Shift Definitions</span></div>
        <button class="rs-defs-x" (click)="closeShiftDefs()"><mat-icon>close</mat-icon></button>
      </div>
      <div class="rs-defs-body">
        <app-shifts embedTab="shifts"></app-shifts>
      </div>
    </div>
  </div>

  <div class="rs-stats">
    <div class="rs-stat"><span class="rs-stat-num rs-c-cr">{{ rows.length }}</span><span class="rs-stat-lbl">Employees</span></div>
    <div class="rs-stat"><span class="rs-stat-num rs-c-green">{{ assignedCount }}</span><span class="rs-stat-lbl">Assigned</span></div>
    <div class="rs-stat"><span class="rs-stat-num rs-c-amber">{{ unassignedCount }}</span><span class="rs-stat-lbl">Unassigned</span></div>
    <div class="rs-stat"><span class="rs-stat-num rs-c-blue">{{ shifts.length }}</span><span class="rs-stat-lbl">Shifts</span></div>
  </div>

  <div class="rs-card">
    <table class="rs-table" *ngIf="rows.length; else empty">
      <thead>
        <tr><th>Employee</th><th>Department</th><th>Assigned Shift</th><th>Timing</th><th>Effective From</th><th class="rs-center">Action</th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rows; trackBy: trackByEmp">
          <td>
            <div class="rs-emp rs-emp--click" (click)="openEmpDrawer(r.emp)" matTooltip="View details & change timeline">
              <div class="rs-av">{{ initials(r.emp) }}</div>
              <div><div class="rs-emp-name">{{ empName(r.emp) }}</div><div class="rs-emp-code">{{ r.emp.employeeId || '—' }}</div></div>
            </div>
          </td>
          <td>{{ deptName(r.emp.departmentId) }}</td>
          <td>
            <span class="rs-shift" *ngIf="r.shiftId; else noShift" [style.background]="shiftColor(r.shiftId) + '1a'" [style.color]="shiftColor(r.shiftId)">
              <span class="rs-shift-dot" [style.background]="shiftColor(r.shiftId)"></span>{{ shiftName(r.shiftId) }}
            </span>
            <ng-template #noShift><span class="rs-unassigned">Unassigned</span></ng-template>
          </td>
          <td><span class="rs-time" *ngIf="r.shiftId">{{ shiftTime(r.shiftId) }}</span><span *ngIf="!r.shiftId" class="rs-muted">—</span></td>
          <td><span *ngIf="r.effectiveFrom">{{ r.effectiveFrom | date:'d MMM yyyy' }}</span><span *ngIf="!r.effectiveFrom" class="rs-muted">—</span></td>
          <td class="rs-center">
            <div class="rs-actions">
              <button class="rs-mini rs-mini--app" (click)="openAssign(r)">{{ r.shiftId ? 'Change' : 'Assign' }}</button>
              <button class="rs-act rs-act--del" *ngIf="r.assignment" matTooltip="Remove assignment" [disabled]="busy[r.assignment.id]" (click)="removeAssignment(r)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #empty>
      <app-empty-state icon="event_note" heading="No employees to roster"
        message="No employees match the current filters. Adjust the search or filters above."></app-empty-state>
    </ng-template>
  </div>
  </ng-container>

  <ng-container *ngIf="activeTab==='requests' && !loading">
    <app-change-requests></app-change-requests>
  </ng-container>
</div>

<div class="rs-drawer-overlay" [class.open]="showForm" (click)="closeForm()"></div>
<div class="rs-drawer" [class.open]="showForm">
  <div class="rs-dr-head">
    <h3>Assign Shift</h3>
    <button class="rs-dr-close" (click)="closeForm()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="rs-dr-body">
    <div class="rs-fg">
      <label>Employee <span class="req">*</span></label>
      <select [(ngModel)]="form.employeeId">
        <option value="">Select employee…</option>
        <option *ngFor="let e of assignableEmployees" [value]="e.id">{{ empName(e) }} ({{ e.employeeId || '—' }})</option>
      </select>
    </div>
    <div class="rs-fg">
      <label>Shift <span class="req">*</span></label>
      <select [(ngModel)]="form.shiftId">
        <option value="">Select shift…</option>
        <option *ngFor="let s of shifts" [value]="s.id">{{ s.name }} · {{ (s.startTime||'').slice(0,5) }}–{{ (s.endTime||'').slice(0,5) }}</option>
      </select>
    </div>
    <div class="rs-fg">
      <label>Effective From <span class="req">*</span></label>
      <input type="date" [(ngModel)]="form.date">
    </div>
    <div class="rs-fg">
      <label>Notes</label>
      <textarea rows="2" [(ngModel)]="form.notes" placeholder="Optional note"></textarea>
    </div>
  </div>
  <div class="rs-dr-foot">
    <button class="rs-btn-ghost" (click)="closeForm()">Cancel</button>
    <button class="rs-btn-primary" [disabled]="submitting" (click)="saveAssignment()">{{ submitting ? 'Saving…' : 'Assign Shift' }}</button>
  </div>
</div>

<div class="rs-drawer-overlay" [class.open]="showPattern" (click)="closePattern()"></div>
<div class="rs-drawer" [class.open]="showPattern">
  <div class="rs-dr-head">
    <h3>Work Pattern</h3>
    <button class="rs-dr-close" (click)="closePattern()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="rs-dr-body" *ngIf="patternEmp">
    <div class="rs-pat-emp">
      <div class="rs-av">{{ initials(patternEmp) }}</div>
      <div><div class="rs-emp-name">{{ empName(patternEmp) }}</div><div class="rs-emp-code">{{ patternEmp.employeeId || '—' }}</div></div>
    </div>

    <div class="rs-fg">
      <label>Work Type <span class="req">*</span></label>
      <select [(ngModel)]="patternForm.workType" (ngModelChange)="onPatternTypeChange()">
        <option value="Office">Office — always work from office (Mon–Fri)</option>
        <option value="Remote">Remote — always work from home</option>
        <option value="Hybrid">Hybrid — some days in office</option>
      </select>
    </div>

    <div class="rs-fg" *ngIf="patternForm.workType==='Hybrid'">
      <label>Office Days (WFO) <span class="req">*</span></label>
      <div class="rs-day-picker">
        <button type="button" class="rs-day-chip" *ngFor="let d of WEEKDAY_PICKER"
                [class.active]="patternForm.officeDays.includes(d.code)" (click)="togglePatternDay(d.code)">{{ d.label }}</button>
      </div>
      <span class="rs-fg-hint">Selected days = office (WFO). Remaining weekdays = work from home (WFH).</span>
    </div>
  </div>
  <div class="rs-dr-foot">
    <button class="rs-btn-ghost" (click)="closePattern()">Cancel</button>
    <button class="rs-btn-primary" [disabled]="patternSaving" (click)="savePattern()">{{ patternSaving ? 'Saving…' : 'Save Pattern' }}</button>
  </div>
</div>

<div class="rs-drawer-overlay" [class.open]="showEmpDrawer" (click)="closeEmpDrawer()"></div>
<div class="rs-drawer" [class.open]="showEmpDrawer">
  <div class="rs-dr-head">
    <h3>Employee Roster</h3>
    <button class="rs-dr-close" (click)="closeEmpDrawer()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="rs-dr-body" *ngIf="drawerEmp">
    <div class="rs-pat-emp">
      <div class="rs-av">{{ initials(drawerEmp) }}</div>
      <div>
        <div class="rs-emp-name">{{ empName(drawerEmp) }}</div>
        <div class="rs-emp-code">{{ deptName(drawerEmp.departmentId) }} · {{ drawerEmp.employeeId || '—' }}</div>
      </div>
    </div>

    <div class="rs-dr-facts">
      <div class="rs-fact"><span class="rs-fact-lbl">Work Type</span><span class="rs-wt rs-wt--{{ workTypeOf(drawerEmp) | lowercase }}">{{ workTypeOf(drawerEmp) }}</span></div>
      <div class="rs-fact"><span class="rs-fact-lbl">Office Days</span><span class="rs-fact-val">{{ patternLabel(drawerEmp) }}</span></div>
      <div class="rs-fact"><span class="rs-fact-lbl">Current Shift</span><span class="rs-fact-val">{{ drawerCurrentShift() }}</span></div>
    </div>

    <p class="rs-dr-title">Change Timeline</p>
    <div class="rs-tl" *ngIf="!historyLoading; else loadingTl">
      <div class="rs-tl-item" *ngFor="let h of empHistory">
        <div class="rs-tl-dot" [ngClass]="h.type==='shift' ? 'tl-blue' : 'tl-cr'">
          <mat-icon>{{ h.type==='shift' ? 'schedule' : 'grid_view' }}</mat-icon>
        </div>
        <div class="rs-tl-body">
          <p class="rs-tl-summary">{{ h.summary }}</p>
          <p class="rs-tl-meta">{{ h.changedByName || 'System' }} · {{ h.createdAt | date:'d MMM yyyy, h:mm a' }}</p>
        </div>
      </div>
      <p class="rs-dr-empty" *ngIf="!empHistory.length">No roster changes recorded yet.</p>
    </div>
    <ng-template #loadingTl><p class="rs-dr-empty">Loading timeline…</p></ng-template>
  </div>
</div>
